import script from "./number.vue?vue&type=script&setup=true&lang=ts"
export * from "./number.vue?vue&type=script&setup=true&lang=ts"

import "./number.vue?vue&type=style&index=0&id=6a9ee82d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a9ee82d"]])

export default __exports__